module.exports = __webpack_public_path__ + "static/media/oberflex-wengereconstitue-2560x1440.7b361c21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-wengereconstitue-2560x1440.jpg
// module id = 1065
// module chunks = 37